import Chart from "chart.js/auto";

export const NWCChartOptions = {
    plugins: {
        datalabels: {
            horizontalAlign: 'left',
            display: false,
            color: '#000',
            align: 'start',
            anchor: 'top',
            padding: '20px',
            font: {
                weight: 'normal',   // specify the font weight
                size: 10,         // specify the font size
            },
        },
        legend: {
            align: 'start',
            labels: {
                font: {
                    size: 8,
                    align: 'left',
                },
                usePointStyle: true,
                generateLabels: function (chart) {
                    let labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                    labels.forEach((label, i) => {
                        label.pointStyle = 'circle';
                        if (i === 1) {
                            label.fillStyle = '#188CE5';
                        }
                    });
                    return labels;
                }
            }
        }
    },
    scales: {
        x:
        {
            grid: {
                display: false
            },
            ticks: {
                
                callback: function (value, index) {
                    return  index % 2 === 0 ? this.getLabelForValue(value) :''
                }
        
                    } 
            }    ,
        revenue: {
            id: 'revenue',
            position: 'right',
            grid: {
                display: true,

            },
            border: {
                dash: [2, 4],
            },
            ticks: {
                callback: function (value, index) {
                    return index % 3 === 0 ? value + 'M' : ''
                }
            }
        },
        nwc: {
            id: 'nwc',
            position: 'left',
            grid: {
                display: true,
            },
            border: {
                dash: [2, 4],
            },
            ticks: {
                callback: function (value, index) {
                    return index % 3 === 0 ? value + '%' : ''
                }
            }
        },
    }
};

export const RevenueGrowthChartOptions = {
    plugins: {
        datalabels: {
            horizontalAlign: 'left',
            display: false,
            color: '#000',
            align: 'top',
            anchor: 'end',
            padding: '20px',
            font: {
                weight: 'normal',
                size: 10,
            },
        },
        legend: {
            align: 'start',
            labels: {
                font: {
                    size: 8,
                    align: 'left'
                },
                usePointStyle: true,
                generateLabels: function (chart) {
                    let labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                    labels.forEach((label,i) => {
                        label.pointStyle = 'circle';
                       
                            label.fillStyle = '#188CE5';
                        
                    });
                    return labels;
                }
            }
        }
    }
    ,
    scales: {
        x: {
            grid: {
                display: false
            },
            ticks: {
                
                callback: function ( value, index) {
                    return  index % 2 === 0 ? this.getLabelForValue(value) :''
                }
            }
        },
        growth: {
            id: 'growth',
            position: 'left',
            grid: {
                display: true,

            },
            border: {
                dash: [2, 4],
            },
            
            ticks: {
                
                callback: function (value, index) {
                    return index % 3 === 0 ? value + '%' : ''
                }
            }

        },
        // y:{
        //     grid: {
        //         display:false
        //     },
            
        // },
        // year : {
        //     id: 'year',
        //     ticks : {
        //         callback: function (value) {
        //             if(value !== undefined) {
        //                 return value ;
        //             }
        //         }
        //     }
        // }
    }
};

export const CashConversionChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        datalabels: {
            horizontalAlign: 'left',
            display: false,
            color: '#000',
            align: 'bottom',
            anchor: 'start',
            font: {
                weight: 'normal',   // specify the font weight
                size: 10,         // specify the font size
            },
        },
        legend: {
            align: 'start',
            labels: {
                font: {
                    size: 8,
                    align: 'left'
                },
                usePointStyle: true,
                generateLabels: function (chart) {
                    let labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                    labels.forEach((label,i) => {
                        label.pointStyle = 'circle';
                    });
                    return labels;
                }
            }
        }
    }
    ,
    scales: {
        x: {

            grid: {

                display: false
            },
            ticks: {
                padding: 10
            }
        },
        y: {

            grid: {
                display: true,
            },
            border: {
                dash: [2, 4],
            },

        }
    }
};